import { useEffect, useRef } from 'react';

/**
 * Runs `reset` when a dialog OPENS — `open` going false → true, or mounting open — and at no
 * other time.
 *
 * ⚠️⚠️ **NOT `useEffect(reset, [open, someList])`** (e2e audit R07, 3 Nov 2026). That shape
 * resets the form whenever the list changes IDENTITY, and a list changes identity on every live
 * refresh, every refetch and — for `projects={[project]}` — every render of the parent. The
 * new-contract dialog emptied itself while somebody was typing into it. The props `reset` reads
 * are read at the moment of opening; what arrives later must be merged in by the dialog itself,
 * never by starting the form over.
 */
export function useOnOpen(open: boolean, reset: () => void): void {
  const latest = useRef(reset);
  /* Declared first, so it has run by the time the effect below reads it. */
  useEffect(() => {
    latest.current = reset;
  });
  useEffect(() => {
    if (open) latest.current();
  }, [open]);
}
